export const MATCHING_FIELDS_NAME_MAPPER = {
    skillsWeight: 'Skills',
    jobTitlesWeight: 'Job Titles',
    industryExperienceWeight: 'Industry Experience',
    managementExperienceWeight: 'Management Experience',
};

export const MINIMUM_MATCHING_SCORE = 30;
